import React, { FC } from 'react';
import { makeStyles, Theme } from '@material-ui/core';
import { isNullOrUndefined } from 'util';
import CurrencyFormat from '../../Core/CurrencyFormat/CurrencyFormat';

const useStyles = makeStyles((theme: Theme) => ({
  price: {
    color: theme.palette.primary.main
  }
}));

interface OptionPriceProps {
  price?: number;
}

const OptionPrice: FC<OptionPriceProps> = ({ price }) => {
  const classes = useStyles();
  if (isNullOrUndefined(price) || price === 0) {
    return null;
  }
  return <CurrencyFormat amount={price} className={classes.price} />;
};

export default OptionPrice;
